import {Basic} from "./Basic";

export class Video
{
    constructor(el)
    {
        const iFrame = this.build_iFrame(this.get_iFrameSrc(el),'w__video--iframe');
        el.insertAdjacentElement('afterend', iFrame);
        el.remove();
    }

    build_iFrame(mySrc, myClass)
    {
        const myIframe = document.createElement('iframe');
        myIframe.src = mySrc;
        myIframe.classList.add(myClass);
        myIframe.frameborder = 0;
        myIframe.allowfullscreen = 1;
        myIframe.setAttribute('allow','autoplay; fullscreen');
        return myIframe;
    }

    get_iFrameSrc(el)
    {
        let url = el.href;
        switch(el.dataset.videoType)
        {
            case 'youtube':
                url = 'https://www.youtube-nocookie.com/embed/' +
                    el.dataset.videoCode +
                    '?showinfo=0' +
                    '&controls=1' +
                    '&fs=1' +
                    '&rel=0' +
                    '&hl=' + Basic.lang +
                    '&autoplay=1' +
                    '&modestbranding=1' +
                    '&showsearch=0';
                break;

            case 'vimeo':
                url = 'https://player.vimeo.com/video/' + el.dataset.videoCode +
                    '?autoplay=1' +
                    '&badge=0' +
                    '&byline=0' +
                    '&portrait=0' +
                    '&title=0' +
                    '&dnt=1';
                break;

            default:
                alert('Unknown video type');
        }
        return url;
    }
}